module.exports = __webpack_public_path__ + "assets/img/consult-icon.526cdc26.png";